import Modal from '../Modals/index';
import React from 'react';
const CustomModal = (props: any) => {
    return (
        <Modal
            open={props.open}
            handleClose={props.handleClose}
            title={props.title}
            subtitle={props.subtitle}
            buttonOneText={props.buttonOneText}
            buttonTwoText={props.buttonTwoText}
            buttonOneAction={props.buttonOneAction}
            buttonTwoAction={props.buttonTwoAction}
            twoButtons={props.twoButtons}
        />
    );
};

export default CustomModal;
